module.exports = __webpack_public_path__ + "img/blockchain.edc9eb37.svg";